import CreateShopOrderRequestModelBase from '../_generated/modelBases/create-shop-order-request-model-base';

export default class CreateShopOrderRequestModel extends CreateShopOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
